import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Table, Spin, Row, Col, Tooltip, Typography } from 'antd';
import { Input, Card, CardBody, Collapse } from 'reactstrap';
import CustomButton from 'components/Button';
import { useSelector, useDispatch } from 'react-redux';
import { getProjectManagers } from '../../../redux/actions/user.action';
import { getFirstAndLastInitials } from '@utils';
import { customStyles } from '../../Projects/components/CustomStyleSelect';
import SelectComponent from './Select';
import './style.scss';
import { getDivisions, addPmInDiv, remPmFromDiv } from '../../../redux/actions/projects.actions';
import { notificationMsg } from '../../../utility/Notification';
import '../../paginationStyle.scss';
import ShowLess from './ShowLess';
import { Link } from 'react-router-dom';
import { getProjects } from '../../../redux/actions/projects.actions';
import { tableSerialNumberColumn } from '../../../utility/Utils';
import { CustomSearch } from 'components/CustomSearch';
import { PAGINATION_PAGE_SIZES, cleanup } from '../../../constants/common';
import { Filter } from 'react-feather';
import Select from '../../../components/Select/Select';
import { useLocation } from 'react-router-dom';
import AppTooltip from '../../../components/AppTooltip/AppTooltip';

const DataTableComponent = ({ getRows, loader, homePermissions, fetchProjectManagers }) => {
  const [accor, setAccor] = useState(false);
  const layoutStore = useSelector((state) => state.layout);
  const theme = useSelector((state) => state.layout.themeMode);
  const dispatch = useDispatch();
  const inputDivisionRef = useRef();
  const inputProjectRef = useRef();
  const [filterText, setFilterText] = React.useState('');
  const projects = useSelector((state) => state.projects);
  const allDivisions = useSelector((state) => state.projects.allDivisions);
  const toHighlightOrFilter = localStorage.getItem('toHighlightOrFilter');
  const currentUserId = localStorage.getItem('loggedInUser');
  const [searchByName, setSearchByName] = useState('');
  const [filteredItems, setFilteredItems] = useState([]);
  const [alDivisions, setAlDivisions] = useState([]);
  const [alPro, setAlPro] = useState([]);
  const [division, setDivision] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const location = useLocation();
  const [tablePagination, setTablePagination] = useState({
    pageNo: 1,
    pageLimit: 10,
  });

  useEffect(() => {
    setFilteredItems(getRows);
  }, [getRows]);
  useEffect(() => {
    dispatch(getProjectManagers());
    projects?.projects?.length < 1 && dispatch(getProjects());
  }, []);
  useEffect(() => {
    setAlPro(projects.projects);
  }, [projects]);
  useEffect(() => {}, [selectedRows]);
  useEffect(() => {
    if (allDivisions?.length > 0) {
      setAlDivisions(allDivisions);
      setAlDivisions((pres) => [...pres, { name: 'N/A', id: null }]);
    }
  }, [allDivisions]);
  useEffect(() => {
    window.onbeforeunload = cleanup;
    return () => {
      cleanup();
      window.onbeforeunload = null;
    };
  }, []);

  const divisionsOptions = alDivisions?.map((division) => {
    return {
      value: division.id,
      label: division.name,
    };
  });
  let projectOptions = alPro?.map((p) => {
    return {
      value: p.id,
      label: p.name,
    };
  });
  projectOptions = projectOptions && [...projectOptions, { value: null, label: 'N/A' }];
  const saveChanges = async (pm_id, type, value, old_value) => {
    try {
      if (type === 'division_id') {
        if (old_value === null && value !== null) {
          const request_body = {
            division_id: value,
            project_manager: pm_id,
            location: location.pathname,
          };
          dispatch(addPmInDiv(request_body));
          notificationMsg('success', 'Project manager is added successfully in division.');
        } else if (old_value !== null && value === null) {
          const request_body_rem = {
            division_id: old_value,
            project_manager: pm_id,
          };
          dispatch(remPmFromDiv(request_body_rem));
          notificationMsg('success', 'Project manager is removed successfully from division.');
        } else if (old_value !== null && value !== null) {
          const request_body = {
            division_id: value,
            project_manager: pm_id,
            location: location.pathname,
          };
          dispatch(addPmInDiv(request_body));
          const request_body_rem = {
            division_id: old_value,
            project_manager: pm_id,
          };
          // dispatch(remPmFromDiv(request_body_rem))
          notificationMsg('success', 'Updated Successfully');
        } else {
        }
      }
      dispatch(getDivisions());
    } catch (e) {
      notificationMsg('error', e?.response?.data?.error);
    }
  };
  const projectHistory = (id) => {
    localStorage.setItem('projectId', id);
  };
  const capitalize = ([first, ...rest]) => first.toUpperCase() + rest.join('');

  const generateProjectStatusBadge = (status, name) => {
    const defaultStatusStyle = { backgroundColor: '#ECFAEC' };
    const refineStatus = capitalize(status, name);

    const allStatus = {
      PRESALE: { backgroundColor: '#E9F8F9', color: 'black' },
      ACTIVE: { backgroundColor: '#ECFAEC', color: 'black' },
      PAUSED: { backgroundColor: '#FDE6E6', color: 'black' },
      CLOSING: { backgroundColor: '#F1E6FF', color: 'black' },
      CLOSED: { backgroundColor: '#FFF5E6', color: 'black' },
    };

    const statusStyle = allStatus.hasOwnProperty(refineStatus) ? allStatus[refineStatus] : defaultStatusStyle;

    const styles = {
      span: {
        padding: '8px',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '12px',
        lineHeight: '12px',
        display: 'inline-block',
        // width: '350px',
      },
    };

    let el;
    el = name ? (
      <span style={{ ...styles.span, ...statusStyle, width: '230px' }}>{name}</span>
    ) : (
      <span style={{ ...styles.span, ...statusStyle }}>{refineStatus}</span>
    );
    return el;
  };

  const sortProjectsByStatus = (array) => {
    const allStatus = {
      PRESALE: 1,
      ACTIVE: 2,
      PAUSED: 3,
      CLOSING: 4,
      CLOSED: 5,
    };

    return array.sort((a, b) => allStatus[capitalize(a.status)] - allStatus[capitalize(b.status)]);
  };

  const clearSearch = () => {
    setFilterText('');
    inputProjectRef?.current?.select?.clearValue();
    inputDivisionRef?.current?.select?.clearValue();
  };

  const columns = useMemo(
    () => [
      {
        title: 'Name',
        width: '150px',
        dataIndex: (row) => row.projectManager,
        // sortable: true,

        render: (cell, row) => {
          return (
            <div className='d-flex align-items-center'>
              <div className='mr-1 nameContainer'>
                {row.slack_avatar ? (
                  <img className='img-circle' src={row.slack_avatar} />
                ) : (
                  <div className='name-circle'>{getFirstAndLastInitials(row.projectManager)}</div>
                )}
              </div>
              <Typography className='proj_col'>{row.projectManager}</Typography>
            </div>
          );
        },
      },
      {
        title: 'Division',
        width: '80px',
        dataIndex: (row) => row.division,
        render: (cell, row) => {
          return (
            <div className='mt-1'>
              <SelectComponent
                styles={customStyles}
                row={row}
                value={row.division_id}
                label={row.division !== 'N/A' ? row.division : <span className='style-higlight-na-data-fields'>N/A</span>}
                type='division_id'
                saveChanges={saveChanges}
                flag='false'
              />
            </div>
          );
        },
      },
      {
        title: 'Projects',
        width: 250,
        dataIndex: (row) => row.division,
        // sortable: true,
        render: (cell, row) => {
          let projects = row.projects;
          sortProjectsByStatus(projects);

          const mutatedProjects = projects.map((el, i) => {
            return (
              <div key={i} className='my-1'>
                <div
                  onClick={() => {
                    projectHistory(el?.id);
                  }}
                  className='history_col'
                >
                  <Link className='project_manager_status status_span status_width' to={`/project-detail/${el?.id}`} target='_blank'>
                    <div>
                      <Tooltip
                        className='minMargin status_width'
                        placement='bottom'
                        enterDelay={100}
                        leaveDelay={100}
                        title={<p className='tooltiptxt'>Project Details</p>}
                        arrow
                      >
                        {generateProjectStatusBadge(el.status, el.name)}
                      </Tooltip>
                      {generateProjectStatusBadge(el.status)}
                    </div>
                  </Link>
                </div>
              </div>
            );
          });
          return (
            <div style={{ marginTop: mutatedProjects?.length === 1 ? '5px' : '' }}>
              <ShowLess items={mutatedProjects} itemsToShow={4} />
            </div>
          );
        },
      },
    ],
    [tablePagination],
  );
  //    Filtering Data
  useEffect(() => {
    let updatedFilteredProjectManagers = getRows;
    //Filter For Division
    updatedFilteredProjectManagers =
      division?.length > 0
        ? updatedFilteredProjectManagers?.filter((el) => division?.find((ele) => ele?.value === el?.division_id))
        : updatedFilteredProjectManagers;
    // Search by Project
    updatedFilteredProjectManagers = searchByName
      ? updatedFilteredProjectManagers?.filter((item) => {
          if (searchByName === 'N/A') {
            return item?.projects?.length === 0;
          }
          return item?.projects?.find((el) => el?.name === searchByName);
        })
      : updatedFilteredProjectManagers;
    // Search For Name
    updatedFilteredProjectManagers =
      filterText && updatedFilteredProjectManagers.length
        ? CustomSearch(updatedFilteredProjectManagers, filterText, 'pm')
        : updatedFilteredProjectManagers;
    setFilteredItems(updatedFilteredProjectManagers);
  }, [filterText, searchByName, division]);
  const handleFilter = (e) => {
    setSearchByName(e);
  };
  const filterProjectManagar = (candidate, input) => {
    const searchName = candidate.label?.split(' ');
    return (
      (searchName[0] && searchName[0].toLowerCase().startsWith(input.toLowerCase().trim())) ||
      (searchName[1] && searchName[1].toLowerCase().startsWith(input.toLowerCase().trim())) ||
      (searchName[2] && searchName[2].toLowerCase().startsWith(input.toLowerCase().trim())) ||
      candidate.label.toLowerCase().startsWith(input.toLowerCase().trim())
    );
  };

  let isDivisionFound = toHighlightOrFilter !== null && filteredItems && filteredItems.length > 0 && filteredItems?.filter(el => ((el.division_id == toHighlightOrFilter) && (el.id == currentUserId)));

  return (
    <div className='invoice-list-dataTable'>
      <Card className="mb-0">
        <CardBody>
          <div className='stickyTop'>
            <Card className='mb-0'>
              <Row className='m-0 justify-content-between match-height align-items-center'>
                <h3 className='m-0 font-weight-bolder'>Project Managers</h3>
                <AppTooltip title="Filters">
                  <div className={isDivisionFound.length > 0 ? 'disable-pointer iconBtn' : 'iconBtn'} onClick={() => setAccor(!accor)}>
                    <Filter className='cursor-pointer mt-0' />
                  </div>
                </AppTooltip>
              </Row>
              <Collapse isOpen={accor}>
                <Row className='mt-0' gutter={[16, 16]}>
                  <Col lg={layoutStore.menuCollapsed === true ? 4 : 6}>
                    <Input
                      id='inputID'
                      className={`${theme === 'light' ? 'inputID' : 'input1'} input_size`}
                      placeholder='Search by Name'
                      value={filterText}
                      onChange={(e) => setFilterText(e.target.value)}
                    />
                  </Col>
                  <Col lg={layoutStore.menuCollapsed === true ? 4 : 6}>
                    <Select
                      ref={inputProjectRef}
                      placeholder='Search by Project'
                      options={projectOptions}
                      value={searchByName !== '' ? searchByName?.label : 'N/A'}
                      maxMenuHeight={140}
                      onChange={(e) => handleFilter(e?.label)}
                      isClearable={true}
                    />
                  </Col>
                  <Col lg={layoutStore.menuCollapsed === true ? 4 : 6}>
                    <Select
                      ref={inputDivisionRef}
                      placeholder='Search by Division'
                      options={divisionsOptions?.length > 0 ? divisionsOptions : [{ value: null, label: 'N/A' }]}
                      value={division?.value !== '' ? division : ''}
                      onChange={(e) => {
                        setDivision(e);
                      }}
                      maxMenuHeight={150}
                      isClearable={true}
                      isMulti={true}
                      filterOption={filterProjectManagar}
                    />
                  </Col>
                  <Col>
                    <div>
                      <CustomButton label='Clear' onClick={clearSearch} />
                    </div>
                  </Col>
                </Row>
              </Collapse>
            </Card>
          </div>
          <div className='pt-2 tableHeight'>
            <Table
              rowKey='id'
              columns={columns}
              dataSource={isDivisionFound.length > 0 ? isDivisionFound : (filteredItems.map((el, i) => {
                el.key = i;
                return el;
              }))}
              loading={{
                indicator: (
                  <div>
                    <Spin size='large' />
                  </div>
                ),
                spinning: loader ? true : false,
              }}
              pagination={{
                showTitle: true,
                defaultPageSize: 10,
                showSizeChanger: true,
                hideOnSinglePage: filteredItems?.length < 10 ? true : false,
                pageSizeOptions: PAGINATION_PAGE_SIZES,
                current: tablePagination.pageNo,
                onChange(current, filters) {
                  setTablePagination({ pageNo: current, pageLimit: filters });
                },
              }}
              scroll={{ x: 'calc(500px + 50%)', y: screen.width <= 1440 ? '61vh' : '70vh' }}
            />
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

DataTableComponent.defaultProps = {
  fetchProjectManagers: true,
};

export default DataTableComponent;
